export const convertBusinessCodeToBusinessName = (
  listBusiness,
  businessCode
) => {
  if (!businessCode || !listBusiness) return;
  return listBusiness.find((item) => item.businessCode === businessCode)?.name;
};
